import React, { useEffect, useState } from "react";
import {
  Modal,
  TextInput,
  Button,
  Stack,
  Card,
  Text,
  Loader,
  Center,
  Chip,
  Group,
} from "@mantine/core";
import integrationService from "../services/integration.service";
import { IntegrationResponse } from "types/responses.type";

const AddIntegrationModal = ({
  opened,
  onClose,
}: {
  opened: boolean;
  onClose: () => void;
}) => {
  const [integrations, setIntegrations] = useState<IntegrationResponse[]>([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (opened) {
      setLoading(true);
      integrationService.getConnectable().then((data) => {
        setIntegrations(data);
        setLoading(false);
      });
    }
  }, [opened]);

  const filteredIntegrations = integrations.filter((integration: any) =>
    integration.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleIntegrationClick = (integrationName: string) => {
    integrationService.start(integrationName);
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Add New Integration"
      centered
    >
      <Stack>
        <TextInput
          placeholder="Search integrations..."
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value)}
        />
        {loading ? (
          <Center>
            <Loader />
          </Center>
        ) : filteredIntegrations.length > 0 ? (
          filteredIntegrations.map((integration: any) => (
            <Card
              key={integration.name}
              shadow="sm"
              padding="lg"
              onClick={() => handleIntegrationClick(integration.name)}
              style={{ cursor: "pointer" }}
            >
              <Group justify="space-between">
                <Text
                  fw={500}
                  style={{ display: "flex", alignContent: "center" }}
                >
                  {integration.displayName}
                </Text>
                <Chip
                  size="xs"
                  variant="outline"
                  style={{ pointerEvents: "none" }}
                >
                  <Text size="xs" c="dimmed">
                    {integration.category}
                  </Text>
                </Chip>
              </Group>
              <Text size="sm" c="dimmed">
                {integration.description}
              </Text>
            </Card>
          ))
        ) : (
          <Text ta="center" c="dimmed">
            No integrations available.
          </Text>
        )}
      </Stack>
    </Modal>
  );
};

export default AddIntegrationModal;
